import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';


const ClassAssembly5E2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/5E/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/5E/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/5E/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/5E/4.webp`;
  
  
 

  const photos = [
    
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
}

  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      EMOTIONS SPEAK BETTER THAN WORDS
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 5E Date: 21 to 23 July 2025  

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The Real Decision Makers in Agriculture”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
         The students of Class 5E presented a special assembly centred on the theme "Emotions Speak Better Than Words," highlighting the significance of expressing emotions in meaningful ways. 
         The assembly began with an introduction to the topic, followed by an inspiring thought for the day, setting the tone for the assembly.
        <br></br>
        The students presented a short skit titled “When Words Fall Short,” effectively portraying the core message of the theme. To conclude the assembly, they recited a heartfelt poem, “When Feelings Speak,” reinforcing the idea that emotions often communicate more deeply than spoken words.
         <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “ In the quiet blaze of feeling, actions sing what words forget.”

   <br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly5E2025;